import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
import { observable, action } from 'mobx';
export let FooterStore = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = observable.ref, _dec4 = observable.ref, _dec5 = observable.ref, _dec6 = observable.ref, _dec7 = observable.ref, _dec8 = observable.ref, _dec9 = observable.ref, _class = class FooterStore {
  constructor(serverData, clientData) {
    // Server data
    _initializerDefineProperty(this, "hideFooterUntilContentReady", _descriptor, this);
    _initializerDefineProperty(this, "currentLocaleId", _descriptor2, this);
    _initializerDefineProperty(this, "isJpFooter", _descriptor3, this);
    _initializerDefineProperty(this, "linkColumns", _descriptor4, this);
    _initializerDefineProperty(this, "structuredLinkColumns", _descriptor5, this);
    _initializerDefineProperty(this, "browseCertificationLinks", _descriptor6, this);
    _initializerDefineProperty(this, "browseTopicLinks", _descriptor7, this);
    _initializerDefineProperty(this, "careerAcceleratorLinks", _descriptor8, this);
    _initializerDefineProperty(this, "bottomLinks", _descriptor9, this);
    _initializerDefineProperty(this, "ufbNotice", _descriptor0, this);
    // Client data
    _initializerDefineProperty(this, "user", _descriptor1, this);
    _initializerDefineProperty(this, "footerExperimentFeatures", _descriptor10, this);
    this.updateServerData(serverData);
    if (clientData) {
      this.updateClientData(clientData);
    }
  }
  updateServerData(data) {
    var _data$hideFooterUntil;
    this.currentLocaleId = data.currentLocaleId;
    this.linkColumns = data.linkColumns;
    this.structuredLinkColumns = data.structuredLinkColumns;
    this.browseCertificationLinks = data.browseCertificationLinks;
    this.browseTopicLinks = data.browseTopicLinks;
    this.careerAcceleratorLinks = data.careerAcceleratorLinks;
    this.bottomLinks = data.bottomLinks;
    this.isJpFooter = data.isJpFooter;
    this.ufbNotice = data.ufbNotice;
    this.hideFooterUntilContentReady = (_data$hideFooterUntil = data === null || data === void 0 ? void 0 : data.hideFooterUntilContentReady) !== null && _data$hideFooterUntil !== void 0 ? _data$hideFooterUntil : false;
  }
  updateClientData(data) {
    this.user = data.user;
    this.footerExperimentFeatures = data.footerExperimentFeatures;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "hideFooterUntilContentReady", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentLocaleId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'en_US';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isJpFooter", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "linkColumns", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "structuredLinkColumns", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "browseCertificationLinks", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "browseTopicLinks", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "careerAcceleratorLinks", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "bottomLinks", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "ufbNotice", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      link: undefined,
      placement: undefined,
      isOnsiteRequestDemo: false
    };
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "footerExperimentFeatures", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateServerData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateServerData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateClientData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateClientData"), _class.prototype), _class);
//# sourceMappingURL=footer.mobx-store.js.map